//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import {isSubtask} from '../utils.js';
import {isoDateFormat} from '../time-utils.js';
import {bulkRescheduleAtEnd} from '../ordered-relation';

export default {
  data() {
    return {
      showDialog: false,
      item: null,
      itemDate: null,
    };
  },
  computed: {
  },
  methods: {
    save() {
      // Don't clear date if there is no parent task.
      if (this.itemDate === null && !isSubtask(this.item)) {
        return;
      }
      this.$reactiveCache.freezeUntil(
        bulkRescheduleAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: [this.item],
          newPPtr: {
            parentClass: 'day',
            parentKey: this.itemDate,
          },
      }));
    },
    scheduleIn(amount, unit) {
      let referenceDate;
      switch (unit) {
        case 'day': referenceDate = moment().startOf('day'); break;
        case 'week': referenceDate = moment().startOf('isoWeek'); break;
        case 'month': referenceDate = moment().startOf('month'); break;
      }
      const parentKey = referenceDate.add(amount, unit).format(isoDateFormat)
      this.$reactiveCache.freezeUntil(
        bulkRescheduleAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: [this.item],
          newPPtr: {
            parentClass: unit,
            parentKey,
          },
        })
      );
      this.showDialog = false;
    },
  },
  mounted() {
    this.$material.locale.firstDayOfAWeek = 1
    this.$root.$on('date-dialog', data => {
      this.showDialog = true
      this.item = data.item
      if (this.item.plannedFor &&
          this.item.plannedFor.parentClass === 'day') {
        this.itemDate = this.item.plannedFor.parentKey;
      }
    });
  },
};
